import { getPolishCountLabel } from '../helpers';

export const listingUrlStateMethods = {
    normalizeFilters(filters = {}) {
        const normalized = {};

        Object.keys(filters)
            .sort()
            .forEach(key => {
                const value = filters[key];

                if (Array.isArray(value)) {
                    normalized[key] = [...value].sort();
                    return;
                }

                if (value) {
                    normalized[key] = value;
                }
            });

        return normalized;
    },

    getListingUrl() {
        const url = new URL(window.location.href);
        const paramsToDelete = [];

        url.searchParams.forEach((value, key) => {
            if (
                key === 'sort' ||
                key === 'page' ||
                key === 'paged' ||
                key.startsWith('filters[')
            ) {
                paramsToDelete.push(key);
            }
        });

        paramsToDelete.forEach(key => url.searchParams.delete(key));

        if (this.isSearchMode()) {
            const phrase = String(
                this.state.phrase || this.getPhraseFromBootstrap()
            ).trim();

            if (phrase !== '') {
                url.searchParams.set('s', phrase);
            }
        }

        if (this.state.sort && this.state.sort !== 'popular') {
            url.searchParams.set('sort', this.state.sort);
        }

        if (this.isSearchMode()) {
            const search = url.searchParams.toString();

            if (!search) {
                return `${url.pathname}${url.hash}`;
            }

            return `${url.pathname}?${search}${url.hash}`;
        }

        Object.entries(this.state.filters || {}).forEach(([key, value]) => {
            if (Array.isArray(value)) {
                value.forEach(item => {
                    url.searchParams.append(`filters[${key}][]`, item);
                });
                return;
            }

            if (value) {
                url.searchParams.set(`filters[${key}]`, value);
            }
        });

        const search = url.searchParams.toString();

        if (!search) {
            return `${url.pathname}${url.hash}`;
        }

        return `${url.pathname}?${search}${url.hash}`;
    },

    formatTotal(total) {
        const normalized = Number(total) || 0;
        const suffix = this.getPolishResultsLabel(normalized);

        return `${normalized.toLocaleString('pl-PL')} ${suffix}`;
    },

    getPolishResultsLabel(total) {
        const i18n = this.bootstrap?.i18n || {};

        return getPolishCountLabel(total, {
            singular: i18n.resultsUnitSingular,
            few: i18n.resultsUnitFew,
            many: i18n.resultsUnitMany,
        });
    },

    getSortFromUrl() {
        const params = new URLSearchParams(window.location.search);
        return params.get('sort') || '';
    },

    getFiltersFromUrl() {
        const params = new URLSearchParams(window.location.search);
        const filters = {};

        params.forEach((value, key) => {
            const arrayMatch = key.match(/^filters\[([^\]]+)\]\[\]$/);
            if (arrayMatch) {
                const filterKey = arrayMatch[1];
                if (!Array.isArray(filters[filterKey])) {
                    filters[filterKey] = [];
                }

                filters[filterKey].push(value);
                return;
            }

            const singleMatch = key.match(/^filters\[([^\]]+)\]$/);
            if (singleMatch) {
                filters[singleMatch[1]] = value;
            }
        });

        return filters;
    },

    getSlugFromUrl(url) {
        try {
            const parsedUrl = new URL(url, window.location.origin);
            const pathParts = parsedUrl.pathname.split('/').filter(Boolean);

            return pathParts[pathParts.length - 1] || '';
        } catch (error) {
            return '';
        }
    }
};
